import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { DUMMY_ORDER } from "../OrderConfirmation/lib";
import {
  Actions,
  type CreateCommentSuccessActionData,
  type GetDetailBeginActionData,
  type GetDetailSuccessActionData,
  type InitSuccessActionData,
  type SetAddCommentModalVisibleActionData,
  type SetShowingDetailIdActionData
} from "./actions";
import { type MemberOrders } from "./types";

const reducer = (state: MemberOrders.AppState = defaultState, action: ReduxAction<any>): MemberOrders.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { items } = action.data as InitSuccessActionData;
      return {
        ...state,
        items,
        status: Status.Ready
      };
    }
    case Actions.GetDetailBegin: {
      const { itemId } = action.data as GetDetailBeginActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [itemId]: {
            detail: null,
            error: null,
            status: Status.Loading
          }
        },
        showingDetailId: itemId
      };
    }
    case Actions.GetDetailFailure: {
      const { error } = action.data as FailureActionData;
      const { itemId } = action.params as GetDetailBeginActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [itemId]: {
            detail: null,
            error,
            status: Status.Failed
          }
        }
      };
    }
    case Actions.GetDetailSuccess: {
      const { itemId } = action.params as GetDetailBeginActionData;
      const detail = action.data as GetDetailSuccessActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [itemId]: {
            detail,
            error: null,
            status: Status.Ready
          }
        }
      };
    }
    case Actions.SetShowingDetailId: {
      const { itemId } = action.data as SetShowingDetailIdActionData;
      return {
        ...state,
        showingDetailId: itemId
      };
    }

    case Actions.CreateCommentBegin: {
      return {
        ...state,
        status: "Creating"
      };
    }
    case Actions.CreateCommentFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.CreateCommentSuccess: {
      const { history } = action.data as CreateCommentSuccessActionData;

      return {
        ...state,
        detail: {
          ...state.detail,
          [state.showingDetailId!]: {
            detail: {
              ...state.detail[state.showingDetailId!].detail!,
              history
            },
            error: null,
            status: Status.Ready
          }
        },
        status: "Ready"
      };
    }

    case Actions.SetAddCommentModalVisible: {
      const { isVisible } = action.data as SetAddCommentModalVisibleActionData;

      return {
        ...state,
        isAddCommentVisible: isVisible
      };
    }
    default:
      return state;
  }
};

export const defaultState: MemberOrders.AppState = {
  detail: {},
  error: null,
  id: "",
  isAddCommentVisible: false,
  items: [],
  showingDetailId: null,
  status: Status.None
};
export const previewState: MemberOrders.AppState = {
  ...defaultState,
  items: [
    {
      id: DUMMY_ORDER.order.orderId,
      currencyCode: DUMMY_ORDER.order.currencyCode,
      number: DUMMY_ORDER.order.number,
      orderDate: DUMMY_ORDER.order.orderedOnDate,
      orderStatusName: "Dummy",
      originName: "Dummy",
      paymentStatusName: "Dummy",
      shippingStatusName: "Dummy",
      totalAmount: DUMMY_ORDER.totals.totalAmount
    }
  ],
  status: Status.None
};
export default wrapReducer({ defaultState, reducer, previewState });
